import { render } from "./EncounterDeck.vue?vue&type=template&id=0133c114&scoped=true"
import script from "./EncounterDeck.vue?vue&type=script&lang=js"
export * from "./EncounterDeck.vue?vue&type=script&lang=js"

import "./EncounterDeck.vue?vue&type=style&index=0&id=0133c114&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0133c114"]])

export default __exports__